export interface UserCommunciationUser {
  userCommunicationUserId?: string;
  userCommunicationId: string;
  userId: string;
}
